import React from 'react';
import { Clock, Download, ListChecks, ShieldAlert } from 'lucide-react';
import type { ListingTab } from './types';

const TABS = [
  { id: 'listings', label: 'All listings', icon: ListChecks },
  { id: 'review', label: 'Review queue', icon: Clock },
  { id: 'reported', label: 'Reported', icon: ShieldAlert },
] as const;

export const ModerationTabs: React.FC<{
  tab: ListingTab;
  onTab: (t: ListingTab) => void;
  showAll: boolean;
  onShowAll: (v: boolean) => void;
  exportUrl: string;
}> = ({ tab, onTab, showAll, onShowAll, exportUrl }) => (
  <div className="mb-6 flex items-center justify-between border-b border-gray-200">
    <div className="flex gap-1">
      {TABS.map(({ id, label, icon: Icon }) => (
        <button
          key={id}
          onClick={() => onTab(id)}
          className={`flex items-center gap-2 border-b-2 px-4 py-2.5 text-sm font-medium transition-colors ${
            tab === id ? 'border-blue-600 text-blue-600' : 'border-transparent text-gray-500 hover:text-gray-700'
          }`}
        >
          <Icon className="h-4 w-4" />
          {label}
        </button>
      ))}
    </div>
    {tab === 'listings' && (
      <div className="mb-2 flex items-center gap-3">
        <label className="flex cursor-pointer items-center gap-2 text-sm text-gray-600">
          <input
            type="checkbox"
            className="h-4 w-4 rounded border-gray-300"
            checked={showAll}
            onChange={(e) => onShowAll(e.target.checked)}
          />
          Show all (incl. drafts/suspended)
        </label>
        <a
          href={exportUrl}
          className="inline-flex items-center gap-2 rounded-lg border border-gray-300 bg-white px-3 py-1.5 text-sm text-gray-700 hover:bg-gray-50"
        >
          <Download className="h-4 w-4" />
          Export CSV
        </a>
      </div>
    )}
  </div>
);
